import styled from 'styled-components';

import { Box } from '@ovpn-ui/core';
import { media } from '@ovpn-ui/styles';

/**
 * @deprecated
 */
export const FieldRowItem = styled(Box)`
    width: ${({ width = '100%' }) => width};
    margin-bottom: 24px;

    ${media.SM`
        width: 100%;
        padding-right: 0;
    `}
`;
